import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./MobSupport.scss";

const MobSupport = () => {
  const [isFaqOpen, setIsFaqOpen] = useState(false);
  const [isContactOpen, setIsContactOpen] = useState(true);

  return (
    <div className="mobSupport-container">
      <h2 className="mobSupport-heading">
        Need help? Don’t sweat it! We are here to help you out!!!
      </h2>

      <div className="mobSupport-section">
        <div
          className="mobSupport-section-header"
          onClick={() => setIsFaqOpen(!isFaqOpen)}
        >
          <h3 className="mobSupport-title">FAQs</h3>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={`mobSupport-chevron ${isFaqOpen ? "open" : ""}`}
          >
            <path d="m18 15-6-6-6 6" />
          </svg>
        </div>
        {isFaqOpen && (
          <div className="mobSupport-section-content">
            <p className="mobSupport-content">
              Visit our{" "}
              <Link
                style={{
                  color: "#FFB000",
                }}
                to="/faq"
              >
                FAQ
              </Link>{" "}
              page for more details.
            </p>
          </div>
        )}
      </div>

      <div className="mobSupport-section">
        <div
          className="mobSupport-section-header"
          onClick={() => setIsContactOpen(!isContactOpen)}
        >
          <h3 className="mobSupport-title">Contact Us</h3>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={`mobSupport-chevron ${isContactOpen ? "open" : ""}`}
          >
            <path d="m18 15-6-6-6 6" />
          </svg>
        </div>
        {isContactOpen && (
          <div className="mobSupport-section-content">
            <div className="mobSupport-row">
              <span className="mobSupport-label">Email</span>
              <span className="mobSupport-value">contact@ballerslife.co</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MobSupport;
